"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodsBannerLazy = exports.BannerComponentLoader = void 0;
var PaymentMethodsBanner_1 = require("@wix/cashier-core/dist/src/services/PaymentMethodsBanner");
var experimentsService_1 = require("@wix/cashier-common/dist/src/utils/experimentsService");
var react_1 = __importDefault(require("react"));
var ModuleRegistry_1 = require("@wix/cashier-common/dist/src/rmc-fork/ModuleRegistry");
var ReactLazyComponent_1 = require("@wix/cashier-common/dist/src/rmc-fork/ReactLazyComponent");
var fedopsLogger_1 = require("../utils/fedopsLogger");
var lazy_1 = require("../utils/biLogger/lazy");
var InteractionName_1 = require("../utils/fedopsLogger/InteractionName");
var config_1 = require("./config");
var BannerComponentLoader = /** @class */ (function (_super) {
    __extends(BannerComponentLoader, _super);
    function BannerComponentLoader(props) {
        return _super.call(this, props, {
            component: config_1.BANNER_COMPONENT_ID,
            files: BannerComponentLoader.buildFiles(props),
            crossorigin: true,
        }) || this;
    }
    BannerComponentLoader.buildFiles = function (props) {
        var isDebug = props.debug || false;
        // the reason for this as that hadron returns different staticsUrl in wix-bootstrap-ng and serverless
        var bannerStaticsBaseUrl = props.bannerSettings.bannerStaticsBaseUrl.replace(/\/$/, '');
        return [
            "".concat(bannerStaticsBaseUrl, "/").concat(config_1.BANNER_BUNDLE_FILE_NAME).concat(isDebug ? '' : '.min', ".css"),
            "".concat(bannerStaticsBaseUrl, "/").concat(config_1.BANNER_BUNDLE_FILE_NAME, ".bundle").concat(isDebug ? '' : '.min', ".js"),
        ];
    };
    return BannerComponentLoader;
}(ReactLazyComponent_1.ReactLazyComponent));
exports.BannerComponentLoader = BannerComponentLoader;
var PaymentMethodsBannerLazy = /** @class */ (function (_super) {
    __extends(PaymentMethodsBannerLazy, _super);
    function PaymentMethodsBannerLazy(props) {
        var _this = _super.call(this, props) || this;
        _this._isMounted = true;
        _this.state = {
            settings: undefined,
            isLazyLoadFailed: false,
        };
        _this.biLoggerFactory = (0, lazy_1.createBiLoggerFactory)(props.meta);
        (0, lazy_1.reportBannerLoadStartBiEvent)(props.meta);
        fedopsLogger_1.fedopsLogger.interactionStarted(InteractionName_1.InteractionName.BannerComponentLoad);
        _this.removeLoadFailureListener = (0, ModuleRegistry_1.getModuleRegistry)().addListener('reactModuleContainer.error', function (error) {
            var _a;
            if ((error === null || error === void 0 ? void 0 : error.name) === 'LazyComponentLoadingError' && ((_a = error.message) === null || _a === void 0 ? void 0 : _a.endsWith(config_1.BANNER_COMPONENT_ID))) {
                console.error("Payment methods banner: Failed to load main bundle", error);
                _this.setStateSafe({ isLazyLoadFailed: true });
            }
        }).remove;
        return _this;
    }
    PaymentMethodsBannerLazy.prototype.fetchBannerSettings = function () {
        return __awaiter(this, void 0, void 0, function () {
            var useNewServerlessApi, e_1, settings;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fedopsLogger_1.fedopsLogger.interactionStarted(InteractionName_1.InteractionName.FetchBannerSettings);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, experimentsService_1.experimentsService.ready()];
                    case 2:
                        _a.sent();
                        useNewServerlessApi = experimentsService_1.experimentsService.isEnabled('specs.payments.EnableServerlessForBanner');
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        useNewServerlessApi = false;
                        return [3 /*break*/, 4];
                    case 4: return [4 /*yield*/, new PaymentMethodsBanner_1.PaymentMethodsBannerService({
                            baseURL: '/',
                            appInstance: this.props.meta.appInstance,
                            revalidateAppInstance: this.props.revalidateAppInstance,
                        }).fetchBannerSettings(useNewServerlessApi)];
                    case 5:
                        settings = _a.sent();
                        fedopsLogger_1.fedopsLogger.interactionEnded(InteractionName_1.InteractionName.FetchBannerSettings);
                        return [2 /*return*/, settings];
                }
            });
        });
    };
    PaymentMethodsBannerLazy.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var settings, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // remove after "EnableServerlessForBanner" FT merge
                        experimentsService_1.experimentsService.init();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.fetchBannerSettings()];
                    case 2:
                        settings = _a.sent();
                        this.setStateSafe({
                            settings: settings,
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        this.setStateSafe({ isLazyLoadFailed: true });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PaymentMethodsBannerLazy.prototype.componentWillUnmount = function () {
        this._isMounted = false;
        if (typeof this.removeLoadFailureListener === 'function') {
            this.removeLoadFailureListener();
        }
    };
    PaymentMethodsBannerLazy.prototype.setStateSafe = function (state) {
        if (this._isMounted) {
            this.setState(state);
        }
    };
    PaymentMethodsBannerLazy.prototype.render = function () {
        var _a = this.state, isLazyLoadFailed = _a.isLazyLoadFailed, settings = _a.settings;
        if (isLazyLoadFailed || !settings) {
            return null;
        }
        return (react_1.default.createElement(BannerComponentLoader, __assign({}, this.props, { bannerSettings: settings, biLoggerFactory: this.biLoggerFactory, fedopsLogger: fedopsLogger_1.fedopsLogger })));
    };
    return PaymentMethodsBannerLazy;
}(react_1.default.Component));
exports.PaymentMethodsBannerLazy = PaymentMethodsBannerLazy;
//# sourceMappingURL=PaymentMethodsBannerLazy.js.map